// @ts-nocheck
/** MI DOMINO - shared config/constants. */
import { playableSides } from '../game/engine';
import { WALLET } from '../state';
import { LANG, t } from '../ui/i18n';
import { API_BASE } from '../net/base';

export const NAMES = ['TÚ', 'Doña Fina', 'El Compay', 'El Tigre'];
export const PREMIOS = [100, 75, 50, 25];
export const TEAM_OF = p => p % 2;
export const SEAT_IDS = { 1: 'seat-right', 2: 'seat-top', 3: 'seat-left' };
export const hasFx = id => WALLET.active.includes(id);
export const MARKET_FEE = 0.10;
/* Founder = the account the SERVER flagged at login/signup (FOUNDER_EMAIL).
   Guests and regular players never see the admin tab or the founder badge.
   (Login reloads the page, so a load-time constant is accurate.) */
export const IS_FOUNDER = (() => {
  try { return !!JSON.parse(localStorage.getItem('account') || '{}').founder; } catch { return false; }
})();
export const WOOD_SW = {
  'skin-caoba': 'linear-gradient(135deg,#6e3a1c,#4a2410)',
  'skin-roble': 'linear-gradient(135deg,#b98a55,#96683a)',
  'skin-ebano': 'linear-gradient(135deg,#3a3a42,#22222a)',
  'skin-oro': 'linear-gradient(135deg,#c9920f,#8a6508)',
};
export const TP_TABS = [
  ['mesas', '🪵 Mesas', '🪵 Tables'], ['banderas', '🌎 Banderas', '🌎 Flags'], ['fichas', '🁢 Fichas', '🁢 Dominos'],
  ['extras', '✨ Extras', '✨ Extras'], ['equipo', '👥 Mi Equipo', '👥 My Team'], ['perfil', '👤 Mi Perfil', '👤 My Profile'],
];
export const RANK_COLORS = ['#9fe1cb', '#f0d78a', '#e9d5ff', '#85b7eb', '#7dd3fc', '#e8912a', '#f0b429', '#a78bfa', '#ffd76e', '#f0b429'];
export const DASH_TABS = [
  ['perfil', '<i class="tp-ico">👤</i>Perfil', '<i class="tp-ico">👤</i>Profile'],
  ['rangos', '<i class="tp-ico">🏆</i>Rangos', '<i class="tp-ico">🏆</i>Ranks'],
  ['tienda', '<i class="tp-ico">🎁</i>Tienda', '<i class="tp-ico">🎁</i>Shop'],
  ['puntos', '<i class="tp-ico">🪙</i>Puntos', '<i class="tp-ico">🪙</i>Points'],
  ['pro', '<i class="tp-ico">👑</i>PRO Club', '<i class="tp-ico">👑</i>PRO Club'],
  ['coleccion', '<i class="tp-ico">💎</i>Colección', '<i class="tp-ico">💎</i>Collection'],
  ['mercado', '<i class="tp-ico tp-coin">$</i>Mercado', '<i class="tp-ico tp-coin">$</i>Market'],
  ['compras', '<i class="tp-ico">🎒</i>Mis Compras', '<i class="tp-ico">🎒</i>My Items'],
  ['equipo', '<i class="tp-ico">🤝</i>Mi Equipo', '<i class="tp-ico">🤝</i>My Team'],
  ['editar', '<i class="tp-ico">📝</i>Editar', '<i class="tp-ico">📝</i>Edit'],
  ['historial', '<i class="tp-ico">📜</i>Historial', '<i class="tp-ico">📜</i>History'],
  ['admin', '<i class="tp-ico">🔧</i>Admin', '<i class="tp-ico">🔧</i>Admin'],
];
export const GAL_FANS = [];
export const FAN_POOL = [
  ['🧔🏽', 'Wilson'], ['👵🏽', 'Doña Carmen'], ['🧢', 'Junior'], ['💃🏽', 'Yesenia'],
  ['🕺🏽', 'Papo'], ['👩🏽‍🦱', 'La Vecina'], ['🎺', 'El Músico'], ['🧉', 'Compa Luis'], ['😎', 'Rafelito'],
];
export const FAN_PHRASES = [
  '¡ESOOO! 🔥', '¡Qué jugada, papá!', '¡Dale que se puede!', 'JAJAJA 😂',
  '¡La mesa está que ARDE!', '¡Cuidado con El Tigre! 👀', '¡Ese es mi equipo! 🎉',
  '¡Cuenta bien, cuenta bien!', '¡Aquí se juega en serio!',
];
/* same gallery chatter, English edition — index-aligned with FAN_PHRASES */
export const FAN_PHRASES_EN = [
  'YESSS! 🔥', 'What a play, papá!', 'Come on, you got this!', 'HAHAHA 😂',
  'This table is ON FIRE!', 'Watch out for El Tigre! 👀', "That's my team! 🎉",
  'Count it right, count it right!', 'We play for real here!',
];
/** A random fan phrase in the active language (reads LANG live). */
export const fanPhrase = () => {
  const i = Math.floor(Math.random() * FAN_PHRASES.length);
  return LANG === 'en' ? FAN_PHRASES_EN[i] : FAN_PHRASES[i];
};
// Online when served over http(s) (web) OR inside the native app (API_BASE points at the server).
export const ONLINE_MODE = location.protocol.indexOf('http') === 0 || API_BASE !== '';
export const canPlay = tile => playableSides(tile).length > 0;
export const handPips = h => h.reduce((s, t) => s + t[0] + t[1], 0);
